import { makeToastFaile } from './common';
import { get } from 'lodash';

/**
 * Helper function để handle Error từ server
 * @param {Error} error
 * @param {boolean} logError - (default: true)
 * @returns {Promise}
 */
export const handleApiError = (
  error,
  customMessage = null,
  logError = true,
) => {
  const errorMessage =
    customMessage || get(error, 'response.data.message') || error.message;

  if (logError) {
    console.error(error);
  }

  if (errorMessage && Array.isArray(errorMessage)) {
    errorMessage.forEach((msg, index) => {
      setTimeout(() => {
        makeToastFaile(msg);
      }, index * 1500);
    });
  } else {
    makeToastFaile(
      typeof errorMessage === 'string' ? errorMessage : 'Có lỗi xảy ra',
    );
  }

  return Promise.reject(error);
};
